<section class="upload-area new-comment-section" id="{{id}}">
  <div class="row comment-border">
    <div class="column medium-12 new-comment-wrapper">
      <div class="row">
        <div class="column medium-12 current-mentions" *ngIf="mentions && mentions.length > 0">
          You are mentioning:
          <span class="mentioned-users">{{mentions}}</span>
        </div>
      </div>
      <div class="row">
        <div class="postAttachment" *ngIf="postUploadResp.length > 0">
          <div class="row" *ngFor="let attachment of postUploadResp">
            <div class="medium-7 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="!attachment.imageType">
              <div class="attachment_name" (click)="downloadDocument(attachment.id, 'preview')">{{attachment.name}}</div>
            </div>
            <div class="medium-7 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="attachment.imageType">
              <img class="image-zoom" [src]="attachment.temporaryURL" (click)="openImage(attachment)"/>
            </div>
            <div class="column medium-1">
              <i class="icon ion-ios-trash commonColor2" (click)="deleteAttachment(attachment.id)"></i>
            </div>
          </div>
        </div>
        <div class="postAttachment" *ngIf="documentsData.length>0">
          <div class="row" *ngFor="let document of documentsData">
            <div class="column medium-7 commonColor2 pointer" attr.title="{{document['file'].name}}">
              <div class="attachment_name">{{document['file'].name}}</div>
            </div>
            <div class="column medium-1" (click)="removeDocument(document)">
              <i class="icon ion-ios-trash commonColor2"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row" [ngClass]="displayType == 'popup'? 'new-comment-post-wrapper': '' ">
        <div class="medium-12">
          <div *ngIf="user.thumbnail && user.thumbnail.length > 0" style="float: left;margin-right: 10px;line-height: 37px;margin-top: -2px">
            <div class="posts-thumbnail" [ngStyle]="{'background': 'url(' + user.thumbnail + ') center center no-repeat'}"></div>
          </div>
          <div class="round user-badge" [hidden]="user.thumbnail" [style.background-color]="user.colorCode">
            {{user.first_name.charAt(0)}}{{user.last_name.charAt(0)}}
          </div>
          <div class="inputContainer">
            <div class="text-area-wrapper">
              <textarea class="direct-text-box new-comment-textarea" id="CommentEditor{{post.id}}" autosize [froalaEditor]="editorOptions" [(froalaModel)]="newCommentMessage" *ngIf="messageHeight"></textarea>
            </div>

            <div class="inputAttachments">
              <span class="pointer" (click)="showMentionWidget()">&#64;</span>
              <div class="zero-right-margin" *ngIf="showMentionDropdown && !isCustomer" (clickOutside)="closeMentionContainer()">
                <app-label-input-search [setData]="mentionUsers" [selectedData]="mentionIds" [displayKey]="'name'" (onLabelSearchSelection)="mentionSelected($event)"
                                        [removeLabelClass] = true (onLabelRemove)="removeMention($event)"></app-label-input-search>
              </div>
              <div class="zero-right-margin" *ngIf="showMentionDropdown && isCustomer" (clickOutside)="closeMentionContainer()">
                <app-label-input-search [setData]="clientInternalUsers" [selectedData]="mentionIds" [displayKey]="'name'" (onLabelSearchSelection)="mentionSelected($event)"
                                        [removeLabelClass] = true (onLabelRemove)="removeMention($event)"></app-label-input-search>
              </div>
              <span class="float-left">
                <label class="button upload_button">
                  <span (click)="triggerFileUpload()"><i class="material-icons">attach_file</i></span>
                </label>
                <input type="file" id="comment-{{post.id}}" (change)="startUpload($event, post.id)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
